import { useEffect, useRef, useState } from 'react';
import { useDispatch } from "react-redux";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, handleDateChange } from '../CommonComponents/CustomHooks';
import { DateBox, FormButton, InputBox } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';

const InScanAtWarehouse = () => {
    const dispatch = useDispatch();
    const inputrefs = useRef([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [timer, setTimer] = useState(0);
    //const Branchcode = GetSession('cookies', 'branchCode');
    //const bcode = Branchcode.split(" : ")[0]
    const selectedDate2 = new Date();
    const dateArr2 = selectedDate2.toDateString().split(" ");
    const formattedDate1 = `${dateArr2[2]}-${dateArr2[1]}-${dateArr2[3]}`;
    const [formData, setFormData] = useState({
        bookingDate: formattedDate1,
        cCode: '',
        actuatWeight: '',
        referenceNo: '',
        pieces: '',
        awbNo: ''
    });

    const handleClear = () => {
        setFormData({
            bookingDate: formattedDate1,
            cCode: '',
            actuatWeight: '',
            referenceNo: '',
            pieces: '',
            awbNo: ''
        });
        GetAwbNoDetail();
        inputrefs.current['txtReferenceNo'].focus()
    }

    const InScanAtWarehouseData = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Operation/InScanAtWarehouse', formData)
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    }

    const GetAwbNoDetail = async (value, CurrentPage, keyname) => {

        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            [keyname]: value,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        await setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetInScanAtWarehouseData', GetData)
        await setTableData(data)
        await setIsLoading(false)
        if (keyname === 'awbno') {
            setFormData({ ...formData, referenceNo: data.Data[0].ReferenceNo, awbNo: value })
        } else if (keyname === 'PickUpReferenceNo') {
            setFormData({ ...formData, referenceNo: value, awbNo: data.Data[0].AwbNo })
        }
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }
    const GetDetail = async (value) => {
        let PageIndex = 1
        let GetData = {
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        await setIsLoading(true)
        let data = await ApiCall('/api/Operation/GetInScanAtWarehouseData', { GetData, PickUpReferenceNo: value.trim() })
        await setTableData(data)
        await setIsLoading(false)
        setFormData({ ...formData, referenceNo: value, awbNo: data.Data[0].AwbNo })
        inputrefs.current['txtReferenceNo'].focus()
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }
    //if (formData.referenceNo !== "") {

    //    InScanAtWarehouseData()
    //}

    console.log(formData.referenceNo, "GHFHGF jhFHFH")
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };
    const handleChange1 = (event, value) => {
        GetAwbNoDetail('', value);
    };
    useEffect(() => {
        GetAwbNoDetail();
    }, [sortConfig])
    useEffect(() => {
        GetAwbNoDetail()
        document.title = 'In-Scan At Warehouse'
        inputrefs.current['txtReferenceNo'].focus()
    }, [])
    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <span className="fs-6 fw-bold headingspan"> {FindTranslatedKey('In-Scan At Warehouse')}</span>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>

                            {/*<InputBox*/}
                            {/*    label='Reference No'*/}
                            {/*    placeholder='Reference No'*/}
                            {/*    inputrefs={inputrefs}*/}
                            {/*    id='txtReferenceNo'*/}
                            {/*    value={formData.referenceNo}*/}
                            {/*    onKeyDown={(e) => {*/}
                            {/*        if (e.key === 'Enter') {*/}
                            {/*            inputrefs.current['txtAwbNo'].focus()*/}
                            {/*        };*/}
                            {/*    }}*/}
                            {/*    maxLength={20}*/}
                            {/*    required={true}*/}
                            {/*    onChange={(e) => setFormData({ ...formData, referenceNo: e.target.value })}*/}
                            {/*    //disabled={true}*/}
                            {/*/>*/}
                            <InputBox
                                label='Pick Up Ref No'
                                required={true}
                                inputrefs={inputrefs}
                                id="txtReferenceNo"
                                PlaceHolderText='Pick Up Ref No'
                                maxLength='50'
                                value={formData.referenceNo}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        if (formData.awbNo && formData.referenceNo) {
                                            inputrefs.current['btnSub'].focus()
                                        }
                                        else {
                                            inputrefs.current['txtAwbNo'].focus()
                                        }
                                        GetAwbNoDetail(formData.referenceNo, '1', 'PickUpReferenceNo')
                                    }
                                }}
                                onChange={(event) => {
                                    setFormData({
                                        ...formData, referenceNo: event.target.value
                                    })
                                }}
                            />
                            <InputBox
                                label='Awb No'
                                PlaceHolderText='Awb No'
                                inputrefs={inputrefs}
                                id='txtAwbNo'
                                value={formData.awbNo}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBookingDate'].focus()
                                        GetAwbNoDetail(formData.awbNo, '1', 'awbno')
                                    };
                                }}
                                maxLength={25}
                                onChange={(e) => {
                                    setFormData({ ...formData, awbNo: e.target.value })
                                }}
                            />


                            <DateBox
                                inputrefs={inputrefs}
                                label="Booking Date"
                                placeholder="Booking Date"
                                id='txtBookingDate'
                                // value={formData.bookingDate ? formData.bookingDate : ''}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                    /*    if (formData.awbNo && formData.referenceNo && formData.bookingDate)*/
                                            inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                required={true}
                                selected={formData.bookingDate === '' ? '' : new Date(formData.bookingDate)}
                                onChange={(e) => handleDateChange(e, setFormData, formData, 'bookingDate')}
                            />

                            {/*<AutoCompleteBox*/}
                            {/*    id="txtCCode"*/}
                            {/*    type="text"*/}
                            {/*    label='CCode'*/}
                            {/*    placeholder='CCode'*/}
                            {/*    onKeyDown={(e) => {*/}
                            {/*        if (e.key === 'Enter') {*/}
                            {/*            inputrefs.current['btnSub'].focus()*/}
                            {/*        }*/}
                            {/*    }}*/}
                            {/*    required={true}*/}
                            {/*    inputrefs={inputrefs}*/}
                            {/*    name='Client Code'*/}
                            {/*    inputValue={formData.cCode ? formData.cCode : ''}*/}
                            {/*    onInputChange={*/}
                            {/*        (event, newInputValue) => {*/}
                            {/*            //handleAutoCompleteChange(event, newInputValue, '', 'GetClient');*/}
                            {/*            //setFormData({ ...formData, cCode: newInputValue })*/}
                            {/*            handleAutoCompleteChange(event, newInputValue, bcode, 'GetClient');*/}
                            {/*            setFormData({ ...formData, cCode: newInputValue })*/}
                            {/*        }}*/}
                            {/*    maxLength='50'*/}
                            {/*    options={autoCompleteOptions}*/}
                            {/*    setOptions={setAutoCompleteOptions}*/}
                            {/*/>*/}

                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            Export={false}
                            handleSubmit={InScanAtWarehouseData}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>

            <Table
                PageName={'InScanAtWarehouse'}
                inputPlaceHolder='Awb No'
                ClickOnLink={GetDetail}
                Filter={false}
                matchingkey={'ReferenceNo'}
                loading={isLoading}
                tableData={tableData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default InScanAtWarehouse;